<template>
  <wrapper class="q-px-lg q-py-xl">
    <h4 class="q-mb-xl">Event log</h4>
    <div class="container-fluid bg-gray q-mb-md">
      <form class="row items-center" @submit.prevent="onSubmit">
        <div class="col-4">
          <md-field>
            <label>Search</label>
            <md-input v-model="search" />
            <span class="md-helper-text">Search event or type</span>
          </md-field>
        </div>
        <div class="col-4">
          <md-button class="md-primary md-raised" type="submit" :disabled="!search">
            <div class="flex items-center"><md-icon class="q-mr-xs">search</md-icon><span>Search</span></div>
          </md-button>
          <md-button class="md-primary" @click="reset">
            <div class="flex items-center"><md-icon class="q-mr-xs">cached</md-icon><span>Reset</span></div>
          </md-button>
        </div>
      </form>
    </div>
    <data-table :columns="columns">
      <md-table-row v-if="!logs.length">
        <md-table-cell class="text-center" colspan="6"> There are no recorded events. </md-table-cell>
      </md-table-row>
      <md-table-row v-for="log in logs" :key="log.id">
        <md-table-cell>{{ log.event }}</md-table-cell>
        <md-table-cell>{{ log.type }}</md-table-cell>
        <md-table-cell>{{ log.createdAt | formatDateTime }}</md-table-cell>
      </md-table-row>
    </data-table>
    <pagination :page.sync="currentPage" :total="totalPages"></pagination>
  </wrapper>
</template>

<script>
import _debounce from 'lodash/debounce';
import Wrapper from '@/components/Wrapper.vue';
import DataTable from '@/components/DataTable.vue';
import Pagination from '@/components/Pagination.vue';
import formatDateMixin from '@/utils/mixins/formatDateMixin';

export default {
  components: {
    Wrapper,
    DataTable,
    Pagination,
  },

  filters: {
    getRole(val) {
      const roles = val.split('+');
      return roles.map((role) => role.replace(/^\w/, (c) => c.toUpperCase()).replace(/_/, ' ')).join(' + ');
    },
  },

  mixins: [formatDateMixin],

  data() {
    return {
      logs: [],
      currentPage: 1,
      totalPages: 1,
      search: '',
    };
  },

  computed: {
    columns() {
      return ['event', 'type', 'time'];
    },
  },

  watch: {
    currentPage() {
      this.debouncedGetData();
    },
  },

  async mounted() {
    this.debouncedGetData = _debounce(this.getData, 300);
    await this.getData();
  },

  methods: {
    getParams() {
      const params = {};

      if (this.search) {
        params.search = this.search;
      }

      if (this.currentPage > 1) {
        params.page = this.currentPage;
      }

      return params;
    },
    debouncedGetData() {},
    async getData() {
      const params = this.getParams();
      const {
        data: {
          data,
          pagination: { page, pages },
        },
      } = await this.$axios.get('/admin/event-logs', { params });

      this.logs = data;
      this.currentPage = page;
      this.totalPages = pages;
    },
    reset() {
      this.search = '';
      this.currentPage = 1;
      this.debouncedGetData();
    },
    onSubmit() {
      this.currentPage = 1;
      this.debouncedGetData();
    },
  },
};
</script>
